<template>
  <div class="home ma-2">
    <v-carousel cycle
                hide-delimiters
                :show-arrows="false">
      <v-carousel-item  v-for="(item,i) in items"
                        :key="i"
                        class="fill-heigth"
                        reverse-transition="slide-x-transition"
                        transition="slide-x-transition">
        <v-img :src="item.src"
               :text="item.text"></v-img>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  data: () => ({
      items: [
        {
          src: 'http://www.pngmart.com/files/7/Halloween-Trick-Or-Treat-PNG-Background-Image.png',
          text: 'some text'
        },
        {
          src: 'https://cwsmgmt.corsair.com/newscripts/landing-pages/wallpaper/v4/Wallpaper-v4-2560x1440.jpg',
          text: 'some text'
        },
        {
          src: 'https://www.edubuntu.org/sites/default/files/docimages/wallpapers-oneiric/The_Grass_aint_Greener_by_fix_pena-full.jpg',
          text: 'some text'
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0901/0816/products/Explosive_Morning_Desktop_1_2048x.JPG?v=1500996502',
          text: 'some text'
        },
      ]
  })
}
</script>
